/* Copyright (c) 2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import { SVGIcon, Tooltip } from "@nordcloud/gnui";

type Element = {
  label?: string;
  value: string;
};

function displayProvidersIcons(list: Element[]) {
  if (list.length === 0) {
    return "–";
  }

  return list?.map((el: Element) => {
    const label = el.label || el.value;

    let iconName = el.value.toLowerCase();
    if (iconName === "ibm_cloud") {
      iconName = "ibmCloud";
    } else if (iconName === "on_premise") {
      iconName = "hybridCloud";
    }

    return (
      <div css={{ marginRight: "0.5rem" }} key={`${label}${el.value}`}>
        <Tooltip caption={label}>
          <SVGIcon
            title={el.value}
            //  @ts-expect-error Component needs to be properly typed
            name={iconName}
          />
        </Tooltip>
      </div>
    );
  });
}

export { displayProvidersIcons };
